/**
 * Created by markusr on 3.6.2015.
 */
define('helperContent-getTaskEntities',[],function() {
    'use strict';

    function _getTaskEntities(entities){
        var tasks = [];

        for (var i = 0; i < entities.length ;i++) {// loop through the whole content

            if(entities[i].typeId != 19) { // if not quiz)
                if (entities[i].typeId != 10){ // if not content page
                    //console.log(entities[i].contentEntity.name + " - entities[i].typeId: ", entities[i].typeId);
                    tasks.push(entities[i]);
                }
                if(entities[i].children.length > 0) {
                    var taskChildren = _getTaskEntities(entities[i].children);

                    if(taskChildren.length > 0){
                        tasks = tasks.concat(taskChildren);
                    }
                }
            }
        }
        return tasks;
    }

    var getTaskEntities = function(data) {
        var taskArr = [],
            contentEntities = data.training.contentEntities;

        if (Array.isArray(contentEntities) && contentEntities.length) {
            taskArr = _getTaskEntities(data.training.contentEntities);
        }

        return taskArr;
    };

    return getTaskEntities;
});

